import React from "react";
import "./EstimationOffer.css";

const EstimationOffer = ({ openModal }) => {
    return (
        <div className="estimation-container">
            <h2 className="estimation-title">
                Nous avons la solution idéale pour vous!
            </h2>
            <p className="estimation-subtext">
                En seulement 12 heures, nous vous offrons le meilleur prix pour vos montres de luxe ou bijoux.<br/>
                Mieux encore... Si vous trouvez un meilleur prix ailleurs, nous vous remboursons la différence!
            </p>

            <h3 className="estimation-subheading">
                Pourquoi choisir notre estimation gratuite?
            </h3>
            <ul className="estimation-list">
                <li className="estimation-item"><span>✔️</span> Vous connaîtrez le prix en 12 heures</li>
                <li className="estimation-item"><span>✔️</span> Approche personnalisée</li>
                <li className="estimation-item"><span>✔️</span> La discrétion est notre priorité</li>
                <li className="estimation-item"><span>✔️</span> Prix juste, si vous trouvez un meilleur prix ailleurs, nous vous remboursons la différence</li>
            </ul>

            <button className="estimation-button" onClick={openModal}>
                Demandez votre estimation &gt;&gt;
            </button>
        </div>
    );
};

export default EstimationOffer;
